import { html } from "lit";
var icon_content_automation_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g fill-rule="evenodd">
      <g fill-rule="nonzero">
        <path
          d="M15.5.75h-14a.75.75 0 00-.75.75v15.4c0 .414.336.75.75.75h14a.75.75 0 00.75-.75V1.5a.75.75 0 00-.75-.75zm-.75 1.5v13.9H2.25V2.25h12.5z" />
        <path d="M15.5 11.95a.75.75 0 01.088 1.495l-.088.005h-14a.75.75 0 01-.087-1.495l.087-.005h14z" />
        <path
          d="M17.593 6.379a.75.75 0 01.864-.498l.085.023 3.717 1.239a1.45 1.45 0 01.951 1.712l-.035.122L18.75 22.26a1.451 1.451 0 01-1.712.951l-.123-.035-10.046-3.348a.75.75 0 01.389-1.446l.085.023 9.999 3.332L21.737 8.55l-3.67-1.223a.75.75 0 01-.496-.864l.022-.084z" />
        <path
          d="M10.605 5.818a2.154 2.154 0 011.632.621l.104.111 3.724 4.256a.753.753 0 01-.07 1.059.752.752 0 01-.993-.004l-.066-.067-3.726-4.257a.65.65 0 00-.97-.011l-.053.067-3.873 5.537a.75.75 0 01-1.279-.779l.05-.08 3.872-5.537c.38-.542.986-.88 1.647-.916zM5.526 3.2a2.325 2.325 0 10-.002 4.65 2.325 2.325 0 00.002-4.65zm0 1.5a.826.826 0 11-.002 1.652.826.826 0 01.002-1.652z" />
      </g>
    </g>
  </svg>
`;
export {
  icon_content_automation_default as default
};
//# sourceMappingURL=icon-content-automation.js.map
